module.exports = __webpack_public_path__ + "static/img/BH04KB.18c98b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BH04KB.jpg
// module id = z3yV
// module chunks = 1